/**
 * @typedef {import('../types').CurrentSite} CurrentSite
 */

/**
 * Reports whether the site has an active subdirectory installation.
 * A populated `subdirectory` property is the authoritative installation state.
 *
 * @param {Partial<CurrentSite>|null|undefined} currentSite
 * @returns {boolean}
 */
export function hasActiveSubdirectory(currentSite) {
    return Boolean(currentSite?.subdirectory);
}
